import Carousel from 'react-bootstrap/Carousel';
const bannerImages = require.context('../img/banners', false, /\.(png|jpe?g|webp|svg)$/);

function CarouselMain({ banner_list = [] }) {
  const getBannerSrc = (fileName) => {
    if (!fileName) return null;
    try {
      return bannerImages(`./${fileName}`);
    } catch (err) {
      return `${process.env.PUBLIC_URL}/img/banners/${fileName}`;
    }
  };

  if (!Array.isArray(banner_list) || banner_list.length === 0) {
    return null;
  }

  return (
    <Carousel>
      {banner_list.map((banner, index) => {
        const src = getBannerSrc(banner.background);
        return (
          <Carousel.Item key={index} interval={2000}>
            {src && <img className="d-block w-100" src={src} alt={`Slide ${index + 1}`} />}
            <Carousel.Caption>
              {banner.title && <h3>{banner.title}</h3>}
              {banner.description && <p>{banner.description}</p>}
              {banner.button && <p dangerouslySetInnerHTML={{ __html: banner.button }} />}
            </Carousel.Caption>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
}

export default CarouselMain;